const featuresPriority = {
  'features-priority-form-date-label': 'Дата',
  'features-priority-filter-title': 'Выберите рекомендации по дате',
  'features-priority-title': 'Установите необходимый порядок рекомендаций',
  'features-priority-update-no-order-changed': 'Порядок приоритетов не изменился',
};

export default featuresPriority;
